// 导航栏用到的图标
export const icons = [
    "icon-meishi",
    "icon-waimai",
    "icon-jiudian",
    "icon-minsu_",
    "icon-kandianying",
    "icon-huoche",
    "icon-_xiuxianyule",
    "icon-shenghuofuwu",
    "icon-lirenmeirong",
    "icon-jinianri",
    "icon-qinzi",
    "icon-yundongjianshen",
    "icon-jiazhuang",
    "icon-onlinetraining",
    "icon-yibao",
    "icon-jiuba",
];

// 导航栏数据

export const navData = [{
        type: "food",
        name: "美食",
        items: [{
            title: "美食",
            items: ["代金券", "甜点饮品", "火锅", "自助餐", "小吃快餐"],
        }, ],
    },
    {
        type: "takeout",
        name: "外卖",
        items: [{
            title: "外卖",
            items: ["美团外卖"],
        }, ],
    },
    {
        type: "民宿",
        name: "酒店",
        items: [{
            title: "热门城市",
            items: ["湘潭", "驻马店", "嘉兴", "北京", "上海"],
        }, ],
    },
    {
        type: "movies",
        name: "猫眼电影",
        items: [{
            title: "热映电影",
            items: [
                "这个杀手不太冷静",
                "长津湖之水门桥",
                "我们的冬奥",
                "好想去你的世界爱你",
                "奇迹·笨小孩",
                "狙击手",
                "尼罗河上的惨案",
                "四海",
                "不要忘记我爱你",
                "花束般的恋爱",
            ],
        }, ],
    },
    {
        type: "plane",
        name: "火车票 / 机票",
        items: [{
                title: "机票",
                items: ["国内机票", "国际/港澳台机票"],
            },
            {
                title: "火车票",
                items: ["火车票"],
            },
        ],
    },
    {
        type: "relax",
        name: "休闲娱乐 / KTV",
        items: [{
            title: "休闲娱乐",
            items: [
                "足疗",
                "按摩",
                "洗浴/汗蒸",
                "酒吧",
                "密室逃脱",
                "轰趴馆",
                "茶馆",
                "私人影院",
                "DIY手工坊",
                "采摘/农家乐",
                "网吧",
                "网咖",
                "游乐游艺",
                "VR",
                "桌面游戏",
                "真人CS",
                "棋牌室",
                "其他玩乐",
            ],
        }, ],
    },
    {
        type: "live",
        name: "生活服务",
        items: [{
            title: "生活服务",
            items: [
                "衣物/皮具",
                "洗护",
                "家政",
                "搬家运输",
                "送水",
                "充值缴费",
                "服饰/鞋包",
                "养护",
                "开锁",
                "换锁",
                "居家",
                "维修管道",
                "疏通",
                "家电维修",
                "清洗",
                "电脑维修",
                "手机维修",
                "证件照/肖像摄影",
                "照片冲印/图文文印",
                "商务服务/法律服务",
                "文化传媒机构",
                "成人用品/情趣用品",
            ],
        }, ],
    },
    {
        type: "beautify",
        name: "丽人 / 美容 / 美发",
        items: [{
            title: "酒店丽人星级",
            items: [
                "美发",
                "美甲",
                "美睫",
                "美容",
                "美体",
                "医学美容",
                "瑜伽",
                "舞蹈",
                "瘦身",
                "纤体",
                "韩式定妆",
                "祛痘",
                "纹身",
                "化妆品",
                "养发",
            ],
        }, ],
    },
    {
        type: "marry",
        name: "结婚",
        items: [{
            title: "结婚",
            items: [
                "婚纱",
                "摄影",
                "旅拍",
                "个性写真",
                "婚宴",
                "婚庆公司",
                "婚纱",
                "礼服",
                "西服定制",
                "婚戒",
                "首饰",
                "婚车租赁",
                "司仪主持",
                "彩妆造型",
                "婚礼跟拍",
                "婚礼小礼品",
                "婚礼服务",
            ],
        }, ],
    },
    {
        type: "child",
        name: "亲子 / 儿童乐园",
        items: [{
                title: "儿童乐园",
                items: ["婴儿游泳", "其它亲子游乐"],
            },
            {
                title: "幼儿教育",
                items: [" 早教中心", " 少儿英语", " 智力开发托班 / 幼儿园"],
            },
            {
                title: "亲子摄影",
                items: ["儿童摄影", "孕妇写真"],
            },
        ],
    },
    {
        type: "sport",
        name: "运动 / 健身",
        items: [{
            title: "运动中心",
            items: ["健身中心", "武术场", "游泳馆", "羽毛球馆", "溜冰场", "射箭馆"],
        }, ],
    },
    {
        type: "jiazhaung",
        name: "家装 / 建材",
        items: [{
                title: "家具家居",
                items: ["家具", "床上用品 / 家纺", "家居饰品", "厨具餐具"],
            },
            {
                title: "家装卖场",
                items: ["建材卖场", "家居卖场", "家居饰品", "灯饰卖场"],
            },
        ],
    },

    {
        type: "study",
        name: "在线培训",
        items: [{
            title: "音乐培训",
            items: [
                "钢琴",
                "吉他",
                "小提琴",
                "古筝",
                "架子鼓",
                "声乐",
                "其他音乐培训",
            ],
        }, ],
    },
    {
        type: "health",
        name: "健康",
        items: [{
            title: "医疗健康",
            items: [
                "医院",
                "齿科",
                "口腔",
                "体检中心",
                "药店",
                "中医",
                "其他健康服务",
            ],
        }, ],
    },
    {
        type: "play",
        name: "酒吧 / 密室逃脱",
        items: [{
            title: "玩乐",
            items: [
                "KTV",
                "酒吧",
                "密室逃脱",
                "游乐",
                "游艺",
                "网吧",
                "网咖",
                "私人影院",
                "DIY手工坊",
                "桌面游戏",
                "采摘/农家乐",
                "棋牌室",
                "轰趴馆",
                "真人CS",
                "VR",
                "其他玩乐",
            ],
        }, ],
    },
];